/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import type { Photo } from './HeroImageGallery.types';

import styles from './HeroImageGalleryLayout.module.scss';

interface HeroImageGalleryLayoutMdProps {
    images: Photo[];
}

export function HeroImageGalleryLayoutMd({ images = [] }: HeroImageGalleryLayoutMdProps) {
    const image1 = images[0] || {};
    const image2 = images[1] || {};
    const image3 = images[2] || {};

    const image1Style = image1.url
        ? { backgroundImage: `url(${image1.url})` }
        : undefined;
    const image2Style = image2.url
        ? { backgroundImage: `url(${image2.url})` }
        : undefined;
    const image3Style = image3.url
        ? { backgroundImage: `url(${image3.url})` }
        : undefined;

    return (
        <div className={cx(styles.layout, styles.md)}>
            <div
                className={cx(styles.photo, styles.hero)}
                style={image1Style}
                role="img"
                aria-label={image1.altText}
            />
            <div className={styles.galleryWrapper}>
                <div className={styles.stack}>
                    <div
                        className={cx(styles.photo, styles.gallery)}
                        style={image2Style}
                        role="img"
                        aria-label={image2.altText}
                    />

                    <div
                        className={cx(styles.photo, styles.gallery)}
                        style={image3Style}
                        role="img"
                        aria-label={image3.altText}
                    />
                </div>
            </div>
        </div>
    );
}
